import { CachedContentArea, StyledContentArea } from '@components';
import { useAppSelector } from '@hooks';
import { getAfterHeaderContentArea, isAfterHeaderContentLoaded } from '@store/app/app.slice';

export const AfterHeaderContentArea = () => {
  const isLoaded = useAppSelector(isAfterHeaderContentLoaded);

  return isLoaded ? (
    <StyledContentArea className='after-header-content-area'>
      <CachedContentArea
        selector={getAfterHeaderContentArea}
        contentAreaName='AfterHeaderContent'
      />
    </StyledContentArea>
  ) : null;
};
